import { render, staticRenderFns } from "./sTable.vue?vue&type=template&id=58fde87f&scoped=true&"
import script from "./sTable.vue?vue&type=script&lang=js&"
export * from "./sTable.vue?vue&type=script&lang=js&"
import style0 from "./sTable.vue?vue&type=style&index=0&id=58fde87f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fde87f",
  null
  
)

export default component.exports